import { defineComponent as h, computed as p, openBlock as s, createBlock as u, withCtx as k, createElementVNode as n, normalizeStyle as y, normalizeClass as d, unref as m, createElementBlock as l, toDisplayString as o, createCommentVNode as i, Fragment as w, renderList as C, resolveDynamicComponent as z, createTextVNode as B } from "vue";
import { useLandingAnimation as S } from "./index127.js";
import V from "./index116.js";
import D from "./index60.js";
const N = {
  key: 0,
  class: "text-xs font-semibold uppercase tracking-widest",
  style: { color: "var(--landing-primary)" }
}, $ = {
  class: "mt-3 text-3xl font-bold md:text-4xl lg:text-5xl",
  style: { color: "var(--landing-dark)" }
}, E = {
  key: 1,
  class: "mt-4 text-base md:text-lg",
  style: { color: "var(--landing-steps-subtext)" }
}, L = {
  key: 0,
  class: "absolute left-[calc(50%+2.5rem)] right-0 top-10 z-0 hidden items-center md:flex",
  "aria-hidden": "true"
}, j = {
  class: "-ml-1 h-4 w-4 shrink-0",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2",
  style: { color: "var(--landing-steps-connector-svg)" }
}, I = { class: "relative z-10 flex flex-col items-center" }, T = {
  class: "mb-4 flex h-20 w-20 items-center justify-center rounded-2xl border shadow-sm",
  style: {
    background: "var(--landing-steps-icon-bg)",
    borderColor: "var(--landing-steps-border)"
  }
}, q = {
  key: 2,
  class: "text-3xl leading-none"
}, A = {
  class: "mb-2 text-xs font-bold uppercase tracking-widest",
  style: { color: "var(--landing-primary)" }
}, F = {
  class: "mb-2 text-lg font-semibold",
  style: { color: "var(--landing-dark)" }
}, P = {
  class: "max-w-[240px] whitespace-pre-line text-sm leading-relaxed",
  style: { color: "var(--landing-steps-subtext)" }
}, W = {
  key: 1,
  class: "my-6 flex flex-col items-center gap-1 md:hidden",
  "aria-hidden": "true"
}, G = {
  class: "h-4 w-4 rotate-90",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2",
  style: { color: "var(--landing-steps-connector-svg)" }
}, H = ["href"], Q = /* @__PURE__ */ h({
  __name: "LandingSteps",
  props: {
    overline: {},
    title: {},
    description: {},
    items: {},
    cta: {},
    bg: { default: "white" },
    primary: { default: "var(--base-colors-primary-primary800)" },
    id: {}
  },
  setup(e) {
    const { el: v, isVisible: a } = S(), f = p(() => ({
      "--landing-steps-border": "var(--base-colors-neutral-neutral250)",
      "--landing-steps-connector": "var(--base-colors-neutral-neutral200)",
      "--landing-steps-connector-svg": "var(--base-colors-neutral-neutral400)",
      "--landing-steps-subtext": "var(--base-colors-neutral-neutral500)",
      "--landing-steps-icon-bg": "var(--base-colors-common-light-gray-f5)"
    }));
    function x(c) {
      return /^[a-z0-9-]+$/.test(c);
    }
    function b(c, r) {
      if (!r.startsWith("#")) return;
      c.preventDefault();
      const t = document.querySelector(r);
      t && t.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    return (c, r) => (s(), u(V, {
      bg: e.bg,
      id: e.id,
      primary: e.primary
    }, {
      default: k(() => [
        n("div", {
          ref_key: "el",
          ref: v,
          style: y(f.value)
        }, [
          n("div", {
            class: d(["mb-14 text-center transition-all duration-700", m(a) ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"])
          }, [
            e.overline ? (s(), l("span", N, o(e.overline), 1)) : i("", !0),
            n("h2", $, o(e.title), 1),
            e.description ? (s(), l("p", E, o(e.description), 1)) : i("", !0)
          ], 2),
          n("div", {
            class: d([
              "relative grid grid-cols-1 gap-0",
              e.items.length === 2 ? "md:grid-cols-2" : e.items.length === 3 ? "md:grid-cols-3" : "md:grid-cols-4"
            ])
          }, [
            (s(!0), l(w, null, C(e.items, (t, g) => (s(), l("div", {
              key: t.number,
              class: d(["relative flex flex-col items-center px-6 text-center", m(a) ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"]),
              style: y({
                transition: "opacity 0.7s ease, transform 0.7s ease",
                transitionDelay: m(a) ? `${g * 100}ms` : "0ms"
              })
            }, [
              g < e.items.length - 1 ? (s(), l("div", L, [
                r[2] || (r[2] = n("div", {
                  class: "h-px flex-1 border-t-2 border-dashed",
                  style: { "border-color": "var(--landing-steps-connector)" }
                }, null, -1)),
                (s(), l("svg", j, [...r[1] || (r[1] = [
                  n("polyline", { points: "9 18 15 12 9 6" }, null, -1)
                ])]))
              ])) : i("", !0),
              n("div", I, [
                n("div", T, [
                  t.icon && typeof t.icon != "string" ? (s(), u(z(t.icon), {
                    key: 0,
                    class: "h-8 w-8",
                    style: { color: "var(--landing-dark)" }
                  })) : typeof t.icon == "string" && x(t.icon) ? (s(), u(D, {
                    key: 1,
                    name: t.icon,
                    size: 32,
                    color: "var(--landing-dark)"
                  }, null, 8, ["name"])) : t.icon ? (s(), l("span", q, o(t.icon), 1)) : i("", !0)
                ]),
                n("span", A, " STEP " + o(t.number), 1),
                n("h3", F, o(t.title), 1),
                n("p", P, o(t.description), 1)
              ]),
              g < e.items.length - 1 ? (s(), l("div", W, [
                r[4] || (r[4] = n("div", {
                  class: "h-6 w-px",
                  style: { background: "var(--landing-steps-connector)" }
                }, null, -1)),
                (s(), l("svg", G, [...r[3] || (r[3] = [
                  n("polyline", { points: "9 18 15 12 9 6" }, null, -1)
                ])]))
              ])) : i("", !0)
            ], 6))), 128))
          ], 2),
          e.cta ? (s(), l("div", {
            key: 0,
            class: d(["mt-14 flex justify-center transition-all delay-500 duration-700", m(a) ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"])
          }, [
            n("a", {
              href: e.cta.href,
              class: "landing-steps-cta inline-flex h-12 items-center gap-2 rounded-xl px-8 text-base font-semibold transition-all duration-200",
              style: { background: "var(--landing-primary)" },
              onClick: r[0] || (r[0] = (t) => b(t, e.cta.href))
            }, [
              B(o(e.cta.label) + " ", 1),
              r[5] || (r[5] = n("svg", {
                class: "h-4 w-4",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                n("line", {
                  x1: "5",
                  y1: "12",
                  x2: "19",
                  y2: "12"
                }),
                n("polyline", { points: "12 5 19 12 12 19" })
              ], -1))
            ], 8, H)
          ], 2)) : i("", !0)
        ], 4)
      ]),
      _: 1
    }, 8, ["bg", "id", "primary"]));
  }
});
export {
  Q as default
};
